import ApiClient from "../../api-client";
import { API_URL } from "../../environment";

export const createSuperAdminUser = ({values, dispatch, token}) => {
    return ApiClient.post(`${API_URL}/user/create-superAdmin-staff`, values, token, dispatch);
};

export const updateSuperAdminUser = ({values, dispatch, token, userId}) => {
    return ApiClient.put(`${API_URL}/user/update-superAdmin-staff?userId=${userId}`, values, token, dispatch);
};

export const updateDefaultOrg = ({values, dispatch, token, userId, defaultOrgId, clinicId, orgId}) => {
    return ApiClient.put(`${API_URL}/user/default-org?userId=${userId}&defaultOrgId=${defaultOrgId}&clinicId=${clinicId}&orgId=${orgId}`, values, token, dispatch);
};

export const updateProfilePhoto = ({values, dispatch, token, userId}) => {
    return ApiClient.put(`${API_URL}/user/update-profile?userId=${userId}`, values, token, dispatch);
};

export const removeOrgClinicAccess = ({ values, dispatch, token}) => {
    return ApiClient.put(`${API_URL}/user/remove-orgAccess`, values, token, dispatch);
};

export const removeUserRoleAccess = ({ values, dispatch, token}) => {
    return ApiClient.put(`${API_URL}/user/remove-userRoleAccess`, values, token, dispatch);
};

export const updateDefaultRole = ({ values, dispatch, token}) => {
    return ApiClient.put(`${API_URL}/user/default-role`, values, token, dispatch);
};

export const activateDeactivateStaff = ({dispatch, token, staffId, isActive, isAccess }) => {
    return ApiClient.put(`${API_URL}/user/activate-deactivate-staff?staffId=${staffId}&isActive=${isActive}&isAccess=${isAccess}`, {}, token, dispatch);
};

export const assignUserToOrg = ({values, dispatch, token}) => {
    return ApiClient.put(`${API_URL}/user/assign-staff-org`, values, token, dispatch);
};

export const addStaffRole = ({values, dispatch, token}) => {
    return ApiClient.put(`${API_URL}/user/add-staff-role`, values, token, dispatch);
};

export const deleteStaff = ({values, dispatch, token, userId}) => {
    return ApiClient.put(`${API_URL}/user/delete-staff?userId=${userId}`, values, token, dispatch);
};

export const getAssignedOrgAndClinic = ({values, dispatch, token, page, limit, searchKey, userId}) => {
    return ApiClient.get(`${API_URL}/user/get-assignedOrg?userId=${userId}&page=${page}&limit=${limit}&searchKey=${searchKey}`, values, token, dispatch);
};

export const getAssignedStaffs = ({values, dispatch, token, orgId, page, limit, searchKey,dataLimit}) => {
    return ApiClient.get(`${API_URL}/user/get-assigned-staff?orgId=${orgId}&page=${page}&limit=${limit}&searchKey=${searchKey}&dataLimit=${dataLimit}`, values, token, dispatch);
};

export const getAssignedClinicStaffs = ({values, dispatch, token, orgId,clinicId, page, limit, searchKey,dataLimit}) => {
    return ApiClient.get(`${API_URL}/user/get-assigned-clinic-staff?orgId=${orgId}&clinicId=${clinicId}&page=${page}&limit=${limit}&searchKey=${searchKey}&dataLimit=${dataLimit}`, values, token, dispatch);
};

export const getStaffsByOrgId = ({values, dispatch, token, orgId, currentHospitalId, page, limit, searchKey, dataLimit}) => {
    return ApiClient.get(`${API_URL}/user/getStaffsBy-orgId?orgId=${orgId}&page=${page}&limit=${limit}&searchKey=${searchKey}&dataLimit=${dataLimit}&currentHospitalId=${currentHospitalId}`, values, token, dispatch);
};

export const getStaffsById = ({dispatch, token, userId}) => {
    return ApiClient.get(`${API_URL}/user/get-staff?userId=${userId}`, null, token, dispatch);
};
export const getUserProfile = ({dispatch, token, values}) => {
    return ApiClient.post(`${API_URL}/user/get-user-profile`, values, token, dispatch);
};

export const getStaffRoles = ({dispatch, token, userId, page, limit, searchKey}) => {
    return ApiClient.get(`${API_URL}/user/roles/get-userRoles?userId=${userId}&page=${page}&limit=${limit}&searchKey=${searchKey}`, null, token, dispatch);
};

export const getStaffs = ({dispatch, token, page, limit, searchKey, dataLimit}) => {
    return ApiClient.get(`${API_URL}/user/getStaffs?page=${page}&limit=${limit}&searchKey=${searchKey}&dataLimit=all`, null, token, dispatch);
};

export const createRole = ({values, dispatch, token}) => {
    return ApiClient.post(`${API_URL}/user/roles/create-role`, values, token, dispatch);
};

export const updateRole = ({values, dispatch, token}) => {
    return ApiClient.put(`${API_URL}/user/roles/update-role`, values, token, dispatch);
};

export const getRoles = ({dispatch, token, roleId, page, limit, searchKey,dataLimit}) => {
    return ApiClient.get(`${API_URL}/user/roles/getAll-roles?roleId=${roleId}&page=${page}&limit=${limit}&searchKey=${searchKey}&dataLimit=${dataLimit}`, null, token, dispatch);
};

export const getObjects = ({dispatch, token}) => {
    return ApiClient.get(`${API_URL}/user/roles/get-objects`, null, token, dispatch);
};

export const getObjectsByPortal = ({values, dispatch, token}) => {
    return ApiClient.get(`${API_URL}/user/roles/getObjectsBy-portal?portalLayout=${values?.portalLayout}`, null, token, dispatch);
};

export const updateRolePermission = ({values, dispatch, token}) => {
    return ApiClient.put(`${API_URL}/user/roles/update-role-permission`, values, token, dispatch);
};

export const updateHiddenObject = ({values, dispatch, token}) => {
    return ApiClient.put(`${API_URL}/user/roles/update-hidden-object`, values, token, dispatch);
};

export const updateMyProfile = ({values, dispatch, token, userId}) => {
    return ApiClient.put(`${API_URL}/user/update-my-profile?userId=${userId}`, values, token, dispatch);
};

export const updateDefaultOrgDetails = ({values, dispatch, token, userId}) => {
    return ApiClient.put(`${API_URL}/user/update-default-org-clinic?userId=${userId}`, values, token, dispatch);
};

export const getUserMessages = ({values, dispatch, token}) => {
    return ApiClient.get(`${API_URL}/user/get-user-messages?folder=${values.folder}&search=${values.searchKey}&userId=${values.userId}&email=${values.userEmail}`, null, token, dispatch);
};

export const updateMessage = ({ messageId, data, dispatch, token }) => {
    return ApiClient.put(`${API_URL}/user/update-message/${messageId}`, data, token, dispatch);
};

export const sendUserMessage = ({payload, dispatch, token}) => {
    return ApiClient.post(`${API_URL}/user/create-user-messages`, payload, token, dispatch);
};

export const deleteMessages = ({ values, dispatch, token }) => {
    return ApiClient.post(`${API_URL}/user/delete-user-messages`, values, token, dispatch);
};
